module.exports = __webpack_public_path__ + "static/media/oil-change.3fd00896.svg";